import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash';
import globalStyles from '../../shared-styles/index';
import { blueGray, solidWhite, white70 } from '../../theme/colors';
import {
  SelectField as MuiSelectField,
  MenuItem as MuiMenuItem
} from 'material-ui';

export default class DateSelect extends Component {
  static get propTypes() {
    return {
      fieldName: PropTypes.string.isRequired,
      valueList: PropTypes.array.isRequired,
      onChange: PropTypes.func.isRequired,
      value: PropTypes.number
    };
  }

  populateDateField(valueList) {
    return valueList.map((dateValue) => {
      return (
        <MuiMenuItem
          value={ dateValue.value }
          key={ dateValue.text }
          primaryText={ dateValue.text }
          style={{ textAlign: 'center' }}
        />
      );
    });
  }

  render() {
    const { fieldName } = this.props;
    const text = capitalize(fieldName);

    return (
      <MuiSelectField
        className={ `date-field ${fieldName}-input` }
        hintText={ text }
        value={ this.props.value }
        onChange={ this.props.onChange }
        autoWidth={ true }
        fullWidth={ true }
        iconStyle={{ display: 'none' }}
        labelStyle={{ ...globalStyles.selectLabelStyle, color: solidWhite }}
        hintStyle={{ ...globalStyles.selectHintStyle, color: white70 }}
        selectedMenuItemStyle={{
          color: blueGray,
          fontWeight: 600
        }}
        dropDownMenuProps={{
          targetOrigin: {
            vertical: 'center',
            horizontal: 'left'
          }
        }}
        underlineStyle = {{
          display: 'none'
        }}
        maxHeight={ 400 }
      >
        { this.populateDateField(this.props.valueList) }
      </MuiSelectField>
    );
  }
};
